module.exports = __webpack_public_path__ + "static/fonts/Fact-ExpandedLight.70bfe02.woff";